module.exports = __webpack_public_path__ + "img/myline.65d8c561.png";